import { createContext, useState } from "react";
import data from "./data";

//create a context, with createContext api
export const userDetailsContext = createContext();
const UserDetailsProvider = (props) => {
	const [item, setItem] = useState(data);
	const [length, setLength] = useState();

	// this state will be shared with all components

	return (
		// this is the provider providing state
		<userDetailsContext.Provider value={{ item, setItem, setLength, length }}>{props.children}</userDetailsContext.Provider>
	);
};

export default UserDetailsProvider;
